import { Typography, Button } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { CoBrowseContext } from "../../../../store/coBrowse.context";
import React from "react";
import { AppContext } from "../../../../store/genesys.context";
import IMessage from "../../../../interface/IMessage";

const ControlOffer = (): React.JSX.Element => {
  const {
    cobrowseServiceStopSession,
    allowControl,
  }: {
    cobrowseServiceStopSession: () => void;
    allowControl: () => void;
  } = React.useContext(CoBrowseContext);

  const {
    getAgentName,
    getLastAgentMessage,
  }: {
    getAgentName: (message: IMessage) => string;
    getLastAgentMessage: () => IMessage;
  } = React.useContext(AppContext);

  return (
    <Grid
      container
      spacing={2}
      sx={{
        mt: "10px",
      }}
    >
      <Grid
        size={6}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-start",
        }}
      >
        <Typography variant="body1" color="initial">
          {getAgentName(getLastAgentMessage())} möchte die Kontrolle übernehmen
        </Typography>
      </Grid>

      <Grid
        size={6}
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "5px",
        }}
      >
        <Button variant="contained" color="primary" onClick={allowControl}>
          Erlauben
        </Button>

        <Button
          variant="outlined"
          color="primary"
          onClick={cobrowseServiceStopSession}
        >
          Ablehnen
        </Button>
      </Grid>
    </Grid>
  );
};

export default ControlOffer;
